import * as React from 'react';

import { type ChatPanelOpenOptions } from '@/layouts/OrganizationDocumentsLayout/ChatPanel/ChatPanelContext';

type ChatPanelState = {
  opened: boolean;
  options?: ChatPanelOpenOptions;
};

type UseChatPanelStateResult = {
  chatPanel: ChatPanelState;
  openPanel: (opts?: ChatPanelOpenOptions) => void;
  closePanel: () => void;
};

export const useChatPanelState = (): UseChatPanelStateResult => {
  const [chatPanel, setChatPanel] = React.useState<ChatPanelState>({ opened: false });

  const openPanel = React.useCallback((opts?: ChatPanelOpenOptions) => {
    setChatPanel({ opened: true, options: opts });
  }, []);

  const closePanel = React.useCallback(() => {
    setChatPanel((prev) => ({ ...prev, opened: false }));
  }, []);

  return { chatPanel, openPanel, closePanel };
};
